let instance;
let listeners = new Set();
let globalState = {
    tenantId: "",
    tenantModel: null,
    aziendaId: 0,
    aziendaModelList: null,
    userId: "",
    userModel: null,
    userPermissions: null,
    version: "",
};

class SharedDatas {
    constructor() {
        if (instance) {
            throw new Error("New instance cannot be created!");
        }

        instance = this;
    }

    getPropertyByName(propertyName) {
        return globalState[propertyName];
    }

    subscribe(listener) {
        if (typeof listener !== "function") {
            return () => {};
        }

        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    }

    setPropertyValue(propertyName, propertyValue) {
        globalState[propertyName] = propertyValue;

        listeners.forEach((listener) => {
            try {
                listener(propertyName, propertyValue);
            } catch (error) {
                // Keep store updates resilient even if a subscriber fails.
                console.error("sharedDatas subscriber error", error);
            }
        });
    }
}

let sharedDatasInstance = Object.freeze(new SharedDatas());

export default sharedDatasInstance;
